var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDowncomponent = function SvgArrowDowncomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.919 6.761.242 2.153a.801.801 0 0 1 0-1.148L1.02.239a.83.83 0 0 1 1.165 0L5.5 3.505 8.815.24a.83.83 0 0 1 1.165 0l.778.766a.802.802 0 0 1 0 1.148L6.08 6.761a.826.826 0 0 1-1.162 0Z",
    fill: "current"
  })));
};
export default SvgArrowDowncomponent;